export default __webpack_public_path__ + "media/vendors/google_play_download-e9cf96a0.svg";